// Path Access
export const MAIN_SYSTEM_LOADER = "/home/tenant_url_prefix";

// Feedback Messages
export const SUCCESS = "SUCCESS";
export const LOADING = "LOADING";
export const FAIL = "FAIL";
export const IDLE = "IDLE";
export const PAGE_ACCESS_DENIED = "PAGE_ACCESS_DENIED";

// API Request Methods
export const POST = "post";
export const GET = "get";

// Other
export const HOME_INDEX = "home";
export const NO_AUTH_TENANT_HOME = "auth";
export const BUTTON_OPEN_PAGE_TYPE = "BUTTON_OPEN_PAGE_TYPE";
export const BUTTON_OPEN_MODAL_TYPE = "BUTTON_OPEN_MODAL_TYPE";
export const HOME_LOGIN_INDEX = "home_login_index";

// OTP Options
export const SEND_OTP_MOBILE = "send_otp_mobile";
export const SEND_OTP_EMAIL = "send_otp_email";

// Tenant Type
export const ADMIN = "admin";
export const TENANT = "tenant";
export const EMPLOYEE = "employee";

// Page/Table Types
export const TENANTS_LIST_TABLE_MAIN = "tenants_list_table_main";
export const PRODUCTS_PAGE = "products_page";
export const PRODUCT_TYPES_MAIN = "product_types_main";
export const PRODUCTS = "products";
export const PRODUCTS_MAIN = "products_main";
export const ADD_EDIT_DELETE_PRODUCT_PACKET_SIZE_TABLE = "add_edit_delete_product_packet_size_table";
export const WAREHOSUE_SITES_PAGE = "warehouse_sites_page";
export const PHYSICAL_WAREHOUSE_SITES_MAIN = "physical_warehouse_sites_main";
export const VIRTUAL_WAREHOUSE_SITES_MAIN = "virtual_warehouse_sites_main";
export const WAREHOUSE_INVENTORY_MAIN = "warehouse_inventory_main";

// Roles
export const ADMINISTRATOR = "administrator";
export const ADD_TENANT = "add_tenant";
export const ADD_PRODUCT_TYPE = "add_product_type";
export const ADD_PRODUCT = "add_product";
export const ADD_WAREHOUSE_SITE = "add_warehouse_site";
export const ADD_SALES_REP = "add_sales_rep";
export const ADD_GOODS_RECEIVED = "add_goods_received";
export const ADD_EMPLOYEE_PROFILE = "add_employee_profile";
export const BACK_DATE_ORDER = "back_date_order";
export const ADD_STOCK_TAKE = "add_stock_take";
export const ADD_AGENCY = "add_agency";
export const ADD_PRODUCT_PRICING = "add_product_pricing";
export const ADD_BUDGET_ALLOCATION = "add_budget_allocation";
export const UPDATE_AGENCY_SALES_REP_ORDER_APPROVALS = "update_agency_sales_rep_order_approvals";
export const UPDATE_BUDGET_ALLOCATION = "update_budget_allocation";
export const TOGGLE_SALES_REP_ALLOWED_PRODUCTS = "toggle_sales_rep_allowed_products";
export const DELETE_ORDER_ITEM = "delete_order_item";
export const CANCEL_ORDER_ITEM = "cancel_order_item";
export const EDIT_ORDER_ITEM = "edit_order_item";
export const ADD_TENANT_MODULE = "add_tenant_module";
export const CREATE_PROMOTION = "create_promotion";
export const CREATE_USSD_CODE = "create_ussd_code";

// Statuses
export const ACTIVE = "active";
export const SUCCESS_LOWER = "success";
export const FAIL_LOWER = "lower";
export const REQUEST_LOWER = "request";
export const APPROVED_LOWER = "approved";
export const PENDING_SUBMISSION_LOWER = "pending_submission";
export const CANCELLED_LOWER = "cancelled";
export const REJECTED_LOWER = "rejected";
export const DISPATCHED_LOWER = "dispatched";
export const LOADING_PRODUCTS_LOWER = "loading_products";
export const GOODS_RECEIVED_LOWER = "goods_received";
export const OFFLOADING_GOODS_LOWER = "offloading_goods";
export const PENDING_APPROVAL_LOWER = "pending_approval";
export const BACK_DATED_LOWER = "back_dated";
export const COMPLETED_LOWER = "completed";
export const UNDERGOING_PROCESSING_LOWER = "undergoing_processing";
export const UPDATE_PRODUCT_LOWER = "update_product";
export const EDIT_ORDER_UNITS_LOWER = "edit_order_units";
export const PENDING_REVIEW_LOWER = "pending_review";
export const TOGGLE_PRODUCT_VIEWABLE_ON_WEBSTORE = "toggle_product_viewable_on_webstore";
export const VALID = "valid";
export const CREATE_PROMOTION_DRAW = "create_promotion_draw";
export const INITIATE_PROMOTION_DRAW = "initiate_promotion_draw";
export const PENDING = "pending";
export const IN_DRAW = "in_draw";
export const COLLECTED = "collected";
export const INVALID = "invalid";


// Settings
export const TENANT_LOGO = "tenant_logo";
export const TENANT_EMAIL_PROVIDER = "tenant_email_provider";
export const TENANT_SMS_PROVIDER = "tenant_sms_provider";
export const ORDER_APPROVALS = "order_approvals";
export const READY_FOR_DISPATCH_NOFIFICATIONS = "ready_for_dispatch_notifications";
export const SYSTEM_BRANDS = "system_brands";
export const STOCK_MOVEMENT_SUSPENSION = "stock_movement_suspension";
export const BULK_SMS_PORTAL = "bulk_sms_portal";

// Adjustment Type
export const ADD_LOWER = "add";
export const SUBTRACT_LOWER = "subtract";

// Other
export const FIRST_APPROVER_LOWER = "first_approver";
export const SECOND_APPROVER_LOWER = "second_approver";
export const NEW = "new";
export const EXISTING = "existing";
export const SELF = "self";
export const AGENCY = "agency";
export const SINGLE = "single";
export const DOUBLE = "double";
export const USSD = "ussd";

// Modules
export const PROMOTIONS = "promotions";
export const INVENTOTY = "inventory";
export const SELECT_MODULE = "select_module";


// Integrations
export const CAMPAIGN_ID_CLIENT_ID_CLIENT_SECRET = "campaign_id_client_id_client_secret";

